import React, { useState } from 'react';
import { Sprout, Calendar } from 'lucide-react';
import '../styles/DashBoard.css';
import PixelGarden from '../components/VirtualGarden';
import PlantCalendar from '../components/PlantCalendar';


const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('garden');

  return (
    <div className="dashboard-main-container">
      <div className="pixel-dashboard-page">
        <div className="pixel-dashboard-header">
          <h1 className="pixel-dashboard-title">My Garden</h1>
          <p className="pixel-dashboard-subtitle">Manage your garden virtually and track your progress</p>
        </div>

        <PixelGarden />
      </div>
    </div>
  );
};

export default Dashboard;